/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TCreateRightRequest } from '../models/TCreateRightRequest';
import type { TCreateRightResponse } from '../models/TCreateRightResponse';
import type { TGetRightResponse } from '../models/TGetRightResponse';
import type { TListRightsResponse } from '../models/TListRightsResponse';
import type { TRightId } from '../models/TRightId';
import type { TUpdateRightRequest } from '../models/TUpdateRightRequest';
import type { TUpdateRightResponse } from '../models/TUpdateRightResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class RightService {
    /**
     * Get Right
     * @param id
     * @param relations
     * @returns TGetRightResponse TGetRightResponse
     * @throws ApiError
     */
    public static getRight(
        id: TRightId,
        relations?: string,
    ): CancelablePromise<TGetRightResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/rights/{id}',
            path: {
                'id': id,
            },
            query: {
                'relations': relations,
            },
        });
    }
    /**
     * Update Right
     * @param id
     * @param requestBody
     * @returns TUpdateRightResponse TUpdateRightResponse
     * @throws ApiError
     */
    public static updateRight(
        id: TRightId,
        requestBody: TUpdateRightRequest,
    ): CancelablePromise<TUpdateRightResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/rights/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete Right
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static deleteRight(
        id: TRightId,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/rights/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * List Rights
     * @param advertiserId
     * @param commercialId
     * @param status
     * @param rightType
     * @param limit
     * @param page
     * @param orderAsJsonString
     * @param relations
     * @returns TListRightsResponse TListRightsResponse
     * @throws ApiError
     */
    public static listRights(
        advertiserId?: string,
        commercialId?: string,
        status?: string,
        rightType?: string,
        limit?: number,
        page?: number,
        orderAsJsonString?: string,
        relations?: string,
    ): CancelablePromise<TListRightsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/rights',
            query: {
                'advertiserId': advertiserId,
                'commercialId': commercialId,
                'status': status,
                'rightType': rightType,
                'limit': limit,
                'page': page,
                'orderAsJsonString': orderAsJsonString,
                'relations': relations,
            },
        });
    }
    /**
     * Create Right
     * @param requestBody
     * @returns TCreateRightResponse TCreateRightResponse
     * @throws ApiError
     */
    public static createRight(
        requestBody: TCreateRightRequest,
    ): CancelablePromise<TCreateRightResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/rights',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
